import firebase from 'firebase/app';
import 'firebase/firestore';
import 'firebase/storage';
import 'firebase/auth';

const config = {
    apiKey: "AIzaSyCmUm6ZITPs4YKQFR-Olvbt0-mvSMkSocs",
    authDomain: "mapfre-b9307.firebaseapp.com",
    databaseURL: "https://mapfre-b9307.firebaseio.com",
    projectId: "mapfre-b9307",
    storageBucket: "mapfre-b9307.appspot.com",
    messagingSenderId: "60680422824",
    appId: "1:60680422824:web:7fc10618b044bdcd"
}

firebase.initializeApp(config)


export const database = firebase.firestore()

export const auth = firebase.auth()

export const storage = firebase.storage()